import { createMutationHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const useUpdateServiceTypeMutation = createMutationHook(
  'transportation.serviceTypeUpdate',
  (params: {
    id: string;
    name?: string;
    description?: string | null;
    isActive?: boolean;
  }) => ({
    transportationServiceTypeUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
          isActive: params.isActive,
        },
      },
      id: true,
      name: true,
      description: true,
      isActive: true,
      isSystemDefault: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: ({ transportationServiceTypeUpdate: serviceType }) => ({
      id: serviceType.id,
      name: serviceType.name,
      description: serviceType.description ?? undefined,
      isActive: serviceType.isActive,
      isSystemDefault: serviceType.isSystemDefault,
      timestamps: {
        createdAt: parseZonedDateTime(serviceType.timestamps.createdAt),
        updatedAt: parseZonedDateTime(serviceType.timestamps.updatedAt),
      },
    }),
  },
);
